<div
    #templateLoaderHost
    id="geo-permissions-manager-template-loader-host"
    class="geocoordinator-permissions-info template-content-host"
    [attr.data-template-url]="parsedConfig()['template_url']"
    [attr.data-event-delay]="parsedConfig()['event_delay']"
    [attr.data-permissionsInfo-status]="permissionsInfo()['status']"
    [attr.data-permissionsInfo-reason]="permissionsInfo()['reason']"
    [attr.data-device-type]="deviceService.deviceType"></div>
